import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AdminBanner = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card rounded-1">
                  <div className="card-header py-3">
                    <h5 className="card-title">Banners Information</h5>
                  </div>
                  <div className="card-body p-3">
                    <form action="#" className="row">
                      <div className="col-md-12">
                        <div className="text-center mb-3">
                          <label
                            className="avatar avatar-xxl profile-cover-avatar m-0 m-auto"
                            // htmlFor="avatar_upload"
                          >
                            <img
                              className="rounded border shadow-sm"
                              src="assets/img/dummy.jpeg"
                              alt="Profile Image"
                            />
                            <input type="file" id="avatar_upload" />
                            <span className="avatar-edit">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-edit-2 avatar-uploader-icon shadow-soft"
                              >
                                <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                              </svg>
                            </span>
                          </label>
                          <p
                            className="fw-light text-info"
                            style={{ fontSize: "12px" }}
                          >
                            .jpg, .jpeg, .png, .bmp recommended size (512 X 512)
                            pixels
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label
                            htmlFor="BannersPosition"
                            className="form-label"
                          >
                            Banners Position
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="BannersPosition"
                            placeholder="Banners Position"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="BannersType" className="form-label">
                            Banners Type
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="BannersType"
                            placeholder="Banners Type"
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label
                            htmlFor="Searchcategory"
                            className="form-label"
                          >
                            Search category
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="Searchcategory"
                            placeholder="Search category"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label htmlFor="OperatingCity" className="form-label">
                            Operating City
                          </label>
                          <select
                            className="form-select"
                            id="OperatingCity"
                            defaultValue="0"
                          >
                            <option value="0" disabled>
                              Select City
                            </option>
                            <option value="1">New York</option>
                            <option value="2">Islamabad</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="StartDate" className="form-label">
                            Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="StartDate"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="EndDate" className="form-label">
                            End Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="EndDate"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label htmlFor="Details" className="form-label">
                            Details
                          </label>
                          <textarea
                            className="form-control"
                            rows="4"
                            id="Details"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="BannersStatus" className="form-label">
                            Banners Status
                          </label>
                          <select
                            className="form-select"
                            id="BannersStatus"
                            defaultValue="0"
                          >
                            <option value="0" disabled>
                              Select Status
                            </option>
                            <option value="1">Active</option>
                            <option value="2">Deactive</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn btn-success">
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-sm-8 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">All Banners</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          <button className="btn btn-success">
                            Export as CSV
                          </button>
                          <button className="btn btn-warning">
                            Bulk CSV Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Id</th>
                            <th>Cover</th>
                            <th>From-To</th>
                            <th>Position</th>
                            <th>Type</th>
                            <th>Value</th>
                            <th>City</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                alt="Category Image"
                                width="40"
                                height="40"
                                className="rounded border"
                              />
                            </td>
                            <td>2022-01-27 - 2024-02-23</td>
                            <td>Top</td>
                            <td>Product</td>
                            <td>Apple</td>
                            <td>Islamabad</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a
                                href="#"
                                className="btn btn-sm btn-primary mx-1"
                              >
                                Edit
                              </a>
                              <a href="#" className="btn btn-sm btn-danger">
                                Delete
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">Showing 1 to 3 of 20 entries</p>
                      <nav aria-label="...">
                        <ul className="pagination">
                          <li className="page-item disabled">
                            <a className="page-link" href="#" tabindex="-1">
                              Previous
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              1
                            </a>
                          </li>
                          <li className="page-item active">
                            <a className="page-link" href="#">
                              2 <span className="sr-only">(current)</span>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              3
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminBanner;
